interface IChatIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const ChatIcon = ({ style, color = '#000000' }: IChatIconProps) => {
  return (
    <div style={{ display: 'flex', ...style }}>
      <svg width="13" height="13" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.9077 9.63069V13.1841C12.9077 13.4984 12.8725 13.7952 12.7933 14.0659C12.4677 15.3493 11.3944 16.1525 9.9163 16.1525H7.52322L4.8662 17.9074C4.77713 17.9679 4.67305 18.003 4.56527 18.0089C4.4575 18.0148 4.35015 17.9913 4.25491 17.9409C4.15967 17.8905 4.08018 17.8151 4.02508 17.723C3.96998 17.6309 3.94139 17.5256 3.9424 17.4185V16.1525C3.04499 16.1525 2.29716 15.8557 1.77807 15.3406C1.25018 14.8167 0.95105 14.0746 0.95105 13.1841V9.63069C0.95105 7.97186 1.98922 6.82815 3.59048 6.67972C3.70485 6.67099 3.81923 6.66226 3.9424 6.66226H9.9163C11.7111 6.66226 12.9077 7.84963 12.9077 9.63069Z"
          fill={color}
        />
        <path
          d="M14.808 12.4245C15.9254 12.4245 16.8668 12.0578 17.5178 11.403C18.1777 10.757 18.5472 9.82277 18.5472 8.71397V4.26132C18.5472 2.20961 16.8756 0.550781 14.808 0.550781H7.32966C5.26211 0.550781 3.59048 2.20961 3.59048 4.26132V4.91613C3.59048 5.16058 3.78403 5.35266 4.03038 5.35266H9.9163C12.3006 5.35266 14.2274 7.26468 14.2274 9.6307V11.988C14.2274 12.2324 14.4209 12.4245 14.6673 12.4245H14.808Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
